// @flow

import * as React from 'react';

import { selectSmdFileInfos, type DomainProduct } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Button, Base } from '@gandi/ui';

import { selectOverviewUrl } from 'src/SimpleHosting/modules/urls';
import { useAppSelector } from 'src/hooks/useAppSelector';

import type { SmdFileInfo } from '../types';

type Props = {
  product: DomainProduct,
  checking: boolean,
  selectedSmdId?: string,
  removedByUser: boolean,
};

export default function ActionsContainer({
  product,
  checking,
  selectedSmdId,
  removedByUser,
}: Props): React.Node {
  const { __ } = useTranslator();
  const overviewUrl = useAppSelector(selectOverviewUrl);

  // FIXME: move SmdFileInfo type to cart
  // $FlowFixMe[incompatible-type]
  const smdFileInfos: void | SmdFileInfo = useAppSelector(state =>
    selectSmdFileInfos(state, { fqdn: product.fqdn }),
  );

  const noSmdFile =
    removedByUser ||
    !smdFileInfos ||
    (smdFileInfos && (!smdFileInfos.name || !smdFileInfos.isValid));

  const noSmdSelected =
    !product.payload?.smd || product.payload.smd_id !== selectedSmdId;

  const disabled = (noSmdFile && noSmdSelected) || checking;

  return (
    <Base marginBottom="base" flex flexAlignItemsStart flexWrap>
      <Button key="cancel" kind="outline" grouped to={overviewUrl}>
        {__('Cancel')}
      </Button>
      <Button
        loading={checking}
        disabled={disabled}
        to={disabled ? undefined : overviewUrl}
        onClick={(evt: SyntheticEvent<HTMLFormElement>) =>
          disabled && evt.preventDefault()
        }
      >
        {__('Submit')}
      </Button>
    </Base>
  );
}
